import React, { useState } from 'react';
import {
  BarChart, Bar, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid,
} from 'recharts';
import Panel from 'src/components/dashboard/Panel';
import ToggleSwitch from './toggle'

const dataYearly = [
  { name: 'Jan', uv: 120 },
  { name: 'Feb', uv: 85 },
  { name: 'Mar', uv: 67 },
  { name: 'Apr', uv: 74 },
  { name: 'May', uv: 89 },
  { name: 'June', uv: 53 },
  { name: 'July', uv: 47 },
  { name: 'Aug', uv: 32 },
  { name: 'Sep', uv: 71 },
  { name: 'Oct', uv: 84 },
  { name: 'Nov', uv: 63 },
  { name: 'Dec', uv: 65 },
];

const dataMontly = [
  { name: '01.02', uv: 354 },
  { name: '02.02', uv: 2578 },
  { name: '03.02', uv: 2000 },
  { name: '04.02', uv: 4383 },
  { name: '05.02', uv: 1890 },
  { name: '06.02', uv: 2390 },
  { name: '07.02', uv: 3490 },
  { name: '08.02', uv: 2000 },
  { name: '09.02', uv: 2780 },
  { name: '10.02', uv: 1890 },
  { name: '11.02', uv: 3578 },
  { name: '12.02', uv: 3644 },
  { name: '13.02', uv: 4000 },
  { name: '14.02', uv: 3000 },
  { name: '15.02', uv: 2000 },
  { name: '16.02', uv: 2780 },
  { name: '17.02', uv: 1890 },
  { name: '18.02', uv: 2390 },
  { name: '19.02', uv: 3490 },
  { name: '20.02', uv: 2000 },
  { name: '21.02', uv: 2780 },
  { name: '22.02', uv: 1890 },
  { name: '23.02', uv: 3578 },
  { name: '24.02', uv: 2390 },
  { name: '25.02', uv: 3578 },
  { name: '26.02', uv: 1890 },
  { name: '27.02', uv: 4000 },
  { name: '28.02', uv: 2378 },
  { name: '28.02', uv: 2378 },

];

const EndingSubscriptions = () => {
  const [isYearly, setYearly] = useState(true);

  const handleChange = () => {
    setYearly(!isYearly);
  };

  return (
    <Panel
      // xl={3}
      // lg={7}
      // md={12}
      title={('Subscriptions coming to an end')}
      subhead="Number of confirmed subscription cancellations"
    >
      <div >
        <ResponsiveContainer height={260}>
          {isYearly
            ? (
              <BarChart data={dataYearly} margin={{ top: 20, left: -15 }}>
                <XAxis dataKey="name" tickLine={false} />
                <YAxis tickLine={false} />
                <Tooltip contentStyle={{ backgroundColor: '#131313' }} />

                <CartesianGrid vertical={false} />
                <Bar dataKey="uv" name="Sales" fill="#dc1860" barSize={10} />
              </BarChart>
            ) : (
              <BarChart data={dataMontly} margin={{ top: 20, left: -15 }}>
                <XAxis dataKey="name" tickLine={false} />
                <YAxis tickLine={false} />
                <Tooltip contentStyle={{ backgroundColor: '#131313' }} />
                <CartesianGrid vertical={false} />
                <Bar dataKey="uv" name="Sales" fill="#1EF1C6" barSize={4} />
              </BarChart>
            )}
        </ResponsiveContainer>
      </div>
      <hr style={{ marginBottom: '0px' }}/>
      <ToggleSwitch label="ending_subscription" handleChange={handleChange}  />
    </Panel>
  );
};

export default EndingSubscriptions
